import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { faqs } from '../data/content';
import { SectionHeading } from './SectionHeading';
import { PlusIcon } from './icons/LineIcons';
export function Faq() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section id="faq" className="relative w-full bg-ink py-20 sm:py-24 lg:py-32" aria-labelledby="faq-title" data-id="element-103" data-mp="1gdgzpcni0i27">
      <div className="mx-auto grid max-w-7xl gap-12 px-5 lg:grid-cols-[0.8fr_1.2fr] lg:gap-16 lg:px-10" data-id="element-104" data-mp="2dzxw8foeqrmw">
        <SectionHeading eyebrow="Preguntas frecuentes" title={<span id="faq-title" data-id="element-106" data-mp="240p1vlpmrb00">
              Antes de <span className="text-gold" data-id="element-107" data-mp="1z370qhhuu02k">empezar</span>
            </span>} data-id="element-105" data-mp="2924mjcnwbfhv" />

        <ul className="divide-y divide-white/[0.07] border-y border-white/[0.07]" data-id="element-108" data-mp="sn3eo63bzjh4">
          {faqs.map((faq, index) => {
          const isOpen = openIndex === index;
          return <li key={faq.question} data-id="element-109" data-mp="nqcxtgjpcjun" data-mpi={index}>
                <h3 data-id="element-110" data-mp="pho7flcibaix">
                  <button type="button" onClick={() => setOpenIndex(isOpen ? null : index)} aria-expanded={isOpen} aria-controls={`faq-panel-${index}`} className="flex w-full items-center justify-between gap-6 py-5 text-left transition-colors duration-300 hover:text-gold" data-id="element-111" data-mp="pih947wlz9u7">
                    <span className="font-sans text-base font-medium text-white transition-colors duration-300" data-id="element-112" data-mp="6qohohx6twol">
                      {faq.question}
                    </span>
                    <span className={`grid h-8 w-8 shrink-0 place-items-center rounded-md border border-steel/70 text-gold transition-transform duration-300 ${isOpen ? 'rotate-45 border-gold/60' : ''}`} data-id="element-113" data-mp="3szfy8wewpofj">
                      <PlusIcon className="h-4 w-4" data-id="element-114" data-mp="3nztjujnce255" />
                    </span>
                  </button>
                </h3>
                <AnimatePresence initial={false} data-id="element-115" data-mp="1uhmfx0ikvxdo">
                  {isOpen ? <motion.div id={`faq-panel-${index}`} initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.32,
                ease: 'easeInOut'
              }} className="overflow-hidden" data-id="element-116" data-mp="1pp352bb9zgck">
                      <p className="max-w-xl pb-6 pr-12 text-sm leading-relaxed text-ash" data-id="element-117" data-mp="28hnlgt9sfszh">
                        {faq.answer}
                      </p>
                    </motion.div> : null}
                </AnimatePresence>
              </li>;
        })}
        </ul>
      </div>
    </section>;
}